export default __webpack_public_path__ + "media/images/partners/Geothink_Logo_T2-aca775ba834fd957f22eca9fee8f857e.jpg";